import React from 'react';

import { Header } from 'components';
import { AboutInfo } from '../../components';

export const About = () => {
  return (
    <>
      <Header />
      <AboutInfo />
    </>
  );
};
